import React from 'react';
import { withTranslation } from 'react-i18next';
import { AppLayout } from '../screens';

const App = () => <AppLayout />;

export default withTranslation()(App);
